import {btnColorSetup} from './btnStyling';

// ---- Link btn ----
export const linkBtn = ({color}) => `
    padding-left: 0;
    padding-right: 0;
    ${btnColorSetup({
        background: `none`,
        txt: `var(--${color})`,
    })};
    &:hover{
        ${btnColorSetup({
            background: `none`,
            txt: `var(--${color}-dark)`,
        })};
    }
    &:disabled,
    &[disabled]{
        ${btnColorSetup({
            background: `none`,
            txt: `var(--disabled)`,
        })};
    }
    border: none!important;
`;

export const defaultLinkBtn = () => `
    &, 
    &:hover{
        ${btnColorSetup({
            background: `none`,
            border: `none`,
            txt: `var(--disabled)`,
        })};
        border: none;
    }
`;
